module.exports = __webpack_public_path__ + "img/cljs.a2f0460d.svg";